/**
 * 2階層目リストの整形
 * <em>タグ内の<br/>で区切られたテキストを個別の要素に変換
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // rich-text__feature-body内のol/ul > li > emを取得
    const nestedListItems = document.querySelectorAll('.rich-text__feature-body ol li em, .rich-text__feature-body ul li em');
    
    nestedListItems.forEach(function(em) {
      // em内のHTMLを取得
      const html = em.innerHTML;
      
      // <br/>または<br>で分割
      const lines = html.split(/<br\s*\/?>/gi);
      
      // 複数行がある場合のみ処理
      if (lines.length > 1) {
        // 各行をspanで囲む
        const newHtml = lines
          .map(function(line) {
            const trimmedLine = line.trim();
            if (trimmedLine) {
              return '<span class="nested-list-item">' + trimmedLine + '</span>';
            }
            return '';
          })
          .filter(function(line) {
            return line !== '';
          })
          .join('');
        
        em.innerHTML = newHtml;
      } else if (lines.length === 1 && lines[0].trim()) {
        // 1行のみの場合もspanで囲む
        em.innerHTML = '<span class="nested-list-item">' + lines[0].trim() + '</span>';
      }
    });
  });
})();

